import React, { useRef } from "react";
import "../styles/HomePageStyles/clientReview.css";
import Aos from "aos";
import "aos/dist/aos.css";
import video1 from "../assets/ClientReview/clvideo1.mp4";
import video2 from "../assets/ClientReview/clvideo2.mp4";
import { Container } from "reactstrap";

const ClientReview = () => {
  Aos.init({
    offset: 0,
    duration: 1000,
    once: true,
    easing: "ease-out-cubic",
    disable: "phone",
  });

  const videoRef = useRef(null);
  const videoRef2 = useRef(null);

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.style.filter = "brightness(1)";
    }
    if (videoRef2.current) {
      videoRef2.current.style.filter = "brightness(1)";
    }
  };

  const handlePause = () => {
    if (videoRef.current) {
      videoRef.current.style.filter = "brightness(0.5)";
    }
    if (videoRef2.current) {
      videoRef2.current.style.filter = "brightness(0.5)";
    }
  };

  return (
    <div className="client_review_wrapper">
      <div className="client_review_container d-flex flex-column justify-content-center align-items-center">
        <Container>
          <div className="client_review_heading text-center mb-5">
            <h2 data-aos="zoom-out">Client Review</h2>
          </div>
          <div className="client_review_content mb-5 d-flex flex-column flex-sm-row justify-content-center align-items-center gap-5">
            <div className="col-12 col-sm-6 col-md-4 client_review_card">
              <video
                className="img-fluid"
                controls
                style={{
                  width: "100%",
                  height: "400px",
                  objectFit: "contain",
                  backgroundColor: "black",
                  borderRadius: "25px",
                }}
                onPlay={handlePlay}
                onPause={handlePause}
                ref={videoRef}
              >
                <source src={video1} type="video/mp4" />
                <source src={video1} type="video/webm" />
                <source src={video1} type="video/ogg" />
                Your browser does not support the video tag.
              </video>
            </div>

            <div className="col-12 col-sm-6 col-md-4 client_review_card">
              <video
                className="img-fluid"
                controls
                style={{
                  width: "100%",
                  height: "400px",
                  objectFit: "contain",
                  backgroundColor: "black",
                  borderRadius: "25px",
                }}
                onPlay={handlePlay}
                onPause={handlePause}
                ref={videoRef2}
              >
                <source src={video2} type="video/mp4" />
                <source src={video2} type="video/webm" />
                <source src={video2} type="video/ogg" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default ClientReview;
